export { default as ConfirmationModal } from './ConfirmationModal.vue';
